import { computed } from "@angular/core";
import { patchState, signalStore, withComputed, withMethods, withState } from "@ngrx/signals";
import { ICommercialSaleFilter } from "src/models/commercial/ICommercialSaleFilter";
import { CompareUtil } from "src/util/tools/compare.util";
const defaultValue: ICommercialSaleFilter = {
    minAskingPrice: 0,
    maxAskingPrice: 0,
    minBuildYear: 0,
    maxBuildYear: 0,
    minGrossArea: 0,
    maxGrossArea: 0,
    minUsableArea: 0,
    maxUsableArea: 0,
    commercialSubTypes: [1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1120, 1121, 1122, 1199],
    agriculturalSubTypes: [1201, 1202, 1203, 1204, 1205, 1206],
    otherEstateTypes: [21, 23, 22, 20, 24, 10, 25, 1],

    since: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    toDate: new Date(),
    simplifiedSearch: false,
};

export const CommercialFilterStore = signalStore(
    { providedIn: "root" },
    withState({ defaultFilterValue: { ...defaultValue }, filterValue: { ...defaultValue } }),
    withComputed(({ filterValue, defaultFilterValue }) => ({
        isDirty: computed(() => {
            let dirty = false;
            dirty = !CompareUtil.deepEquals(filterValue(), defaultFilterValue());
            return dirty;
        }),
    })),

    withMethods((store) => ({
        setFilter(value: ICommercialSaleFilter): void {
            patchState(store, { filterValue: value });
        },
        resetFilter(): void {
            patchState(store, { filterValue: store.defaultFilterValue() });
        },
    }))
);
